import * as React from 'react'
import { connect } from 'react-redux'
import { RouterState, RouterAction, routerActions } from 'react-router-redux'

import { AppBarContainer } from './CustomAppBar'
import { Api } from '../services/api/api'
import { Job } from '../types'
import { List } from '@material-ui/core'
import { CompletedJobsListItem } from '../components/CompletedJobsListItem'
import { LoadingSpinner } from '../components/LoadingSpinner'
import PageTitle from '../components/PageTitle'

import { setCompletedJob } from '../actions/setCompletedJob'
import { StoreState } from '../reducers'
import { ROUTES } from '../constants/routes'
import { JobStatus } from '../types/enums/JobStatus'

import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Strings } from '../localization'
import { StringResources } from '../localization/StringResources'

import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'

import { ActionType as ErrorInfoActionType, Actions as ErrorActions } from '../actions/errorInfo'
import { Error as ErrorInfo } from '../types/Errors/Error'
import Mapper from '../utils/Mapper'
import {LocationDescriptor} from 'history';

interface State {
  jobs: Job[]
  isJobsReceived: boolean
}

interface CompletedJobsProps {
  onSetCompletedJob: (completedJob: Job) => void
  routePush: (location: LocationDescriptor) => RouterAction
  onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
  completedJob: Job | null
}

export class CompletedJobsContainer extends React.Component<CompletedJobsProps, State> {
  constructor(props: any) {
    super(props)
    this.state = {
      jobs: [],
      isJobsReceived: false
    }
  }

  getCompletedJobs() {
      const requests = [Api.getCompletedJobs(), Api.getActiveJobs()];
      Promise.all(requests).then((results) => {
          const jobs = [];
          for (const arr of results)
              Array.prototype.push.apply(jobs, arr);

          const repostedJobs = jobs.map((j:Job) => j.originatedFrom).filter(id => !!id);
          const notReposted = jobs.filter((j:Job) => repostedJobs.indexOf(j.id) === -1);
          this.setState({
              jobs: notReposted.sort((a:Job, b:Job) => b.modifyDate! - a.modifyDate!),
              isJobsReceived: true
          })
      }).catch((err) => {
          console.log('completed jobs getting error')
          console.log(err)
          this.setState({jobs: []})
          this.props.onErrorEvent(Mapper.mapError(err))
      })
  }
  componentDidMount() {
    this.getCompletedJobs()
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props.completedJob !== nextProps.completedJob) {
      this.props.routePush(ROUTES.COMPLETED_JOB_DETAILED)
    }
  }

  showCompletedJob = (job: Job) => {
    this.props.onSetCompletedJob(job)
  }

  render() {
    return (
        <BaseContainer pageName={EventType.COMPLETED_JOBS}>
          <AppBarContainer
            isIconButtonsShown={true}
            isMenuShown={true}
          />
          <PageTitle text={StringResources.getString(Strings.CompletedJobs.Title)} />
          <LoadingSpinner show={!this.state.isJobsReceived} />
          {
            this.state.jobs.length !== 0 ?
              <List className="completed-jobs-list">
                <PerfectScrollbar className="completed-jobs-scroll">
                  {
                    this.state.jobs.map((item, index) =>
                      <CompletedJobsListItem
                        job={item}
                        id={index}
                        key={item.id}
                        showCompletedJob={this.showCompletedJob}
                        routePush = {this.props.routePush}
                      />
                    )
                  }
                </PerfectScrollbar>
              </List>
              : this.state.isJobsReceived ?
                <div className="no-completed-jobs-container">
                  <h2>{StringResources.getString(Strings.CompletedJobs.Headers.NoJobsFound)}</h2>
                </div>
                :
                null
          }
        </BaseContainer>
    )
  }
}

function mapStateToProps(state: StoreState) {
  return {
    routing: state.routing,
    completedJob: state.completedJob
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    routePush: (location: LocationDescriptor) => dispatch(routerActions.push(location)),
    onErrorEvent: (errorInfo: ErrorInfo) => dispatch(ErrorActions.newError(errorInfo)),
    onSetCompletedJob: (completedJob: Job) => dispatch(setCompletedJob(completedJob))
  }
}

export const CompletedJobs = connect(
  mapStateToProps,
  mapDispatchToProps
)(CompletedJobsContainer)



// WEBPACK FOOTER //
// ./src/containers/CompletedJobs.tsx